import {Component, Input, OnInit} from '@angular/core';
import {StatusColor} from '../../models/status-color.enum';

@Component({
  selector: 'app-simple-chart',
  templateUrl: './simple-chart.component.html',
  styleUrls: ['./simple-chart.component.scss']
})
export class SimpleChartComponent implements OnInit {
  @Input() performance: any;
  StatusColor = StatusColor;

  constructor() {}

  ngOnInit(): void {}
}
